// extracted by mini-css-extract-plugin
export default {"full-width":"QUSniD","fullWidth":"QUSniD","root":"mQ_DVf","initialized":"GQnz1s","testNodeWrapper":"uWpgu6","testText":"kK60SA"};